// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applyVisualModeFromStorage } from './utils/visualMode';
import { VisualModeProvider } from './context/VisualModeContext';

// Hiljennä turhat konsolilokit tuotannossa (jätä warn/error näkyviin).
// Voit ohittaa hiljennyksen asettamalla REACT_APP_DEBUG_LOGS=1 build-ympäristöön.
/* eslint-disable no-console */
if (
  process.env.NODE_ENV === 'production' &&
  String(process.env.REACT_APP_DEBUG_LOGS || '').trim() !== '1'
) {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.trace = noop;
  console.group = noop;
  console.groupCollapsed = noop;
  console.groupEnd = noop;
  console.time = noop;
  console.timeEnd = noop;
}
/* eslint-enable no-console */

// Lue talteen edellinen visuaalinen tila (full / minimal) heti käynnistyksessä
applyVisualModeFromStorage();

/**
 * Mounttaa React-sovelluksen vasta kun #root on varmasti olemassa.
 * Tämä estää tuotannossa nähdyn React #299 -virheen tilanteissa,
 * joissa bundle ehtii suorittua ennen kuin DOM on täysin valmis.
 */
const mountApp = () => {
  const container = document.getElementById('root');

  if (!container) {
    console.error('React mount epäonnistui: #root puuttuu DOM:ista.');
    return;
  }

  const root = ReactDOM.createRoot(container);

  root.render(
    <React.StrictMode>
      <VisualModeProvider>
        <App />
      </VisualModeProvider>
    </React.StrictMode>
  );
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountApp, { once: true });
} else {
  mountApp();
}

// Web Vitals: ei logiteta tuotannossa. Jos haluat mitat kehityksessä konsoliin,
// poista kommentti alla olevasta rivistä.
// if (process.env.NODE_ENV !== 'production') reportWebVitals(console.log);

reportWebVitals();